package com.trevorwiebe.timesheet.core.data

import kotlinx.serialization.Serializable

/**
 * The stored counter for invoice or settlement numbers. Numbers of deleted drafts go into [free]
 * and are handed out again, lowest first, so no number is skipped.
 */
@Serializable
data class NumberCounter(val next: Int = 0, val free: List<Int> = emptyList()) {

    /** The number to use now, and the counter after using it. */
    fun claim(): Pair<Int, NumberCounter> {
        val reused = free.minOrNull() ?: return next to copy(next = next + 1)
        return reused to copy(free = free - reused)
    }

    fun release(number: Int): NumberCounter = when {
        number >= next || number in free -> this
        number == next - 1 -> copy(next = number)
        else -> copy(free = free + number)
    }
}
